  <div class="dtp-host">

    <!-- ── Trigger ── -->
    <div class="dtp-trigger"
         cdkOverlayOrigin
         #origin="cdkOverlayOrigin"
         [class.open]="open"
         (click)="toggleOpen()">
  
      <span class="dtp-trigger__icon">⏰</span>
  
      <span class="dtp-trigger__text">
        <ng-container *ngIf="displayValue; else placeholder">
          {{ displayValue }}
        </ng-container>
  
        <ng-template #placeholder>
          <span class="dtp-trigger__placeholder">
            {{ this.placeholder }}
          </span>
        </ng-template>
      </span>
  
      <span *ngIf="selectedDate"
            class="dtp-trigger__clear"
            (click)="clear($event)">
            <mat-icon style="color: red;">close</mat-icon>
      </span>
  
    </div>
  
    <!-- ── OVERLAY PANEL (IMPORTANT CHANGE) ── -->
    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="origin"
      [cdkConnectedOverlayOpen]="open"
      [cdkConnectedOverlayHasBackdrop]="true"
      (backdropClick)="open = false"
      [cdkConnectedOverlayPanelClass]="'dtp-overlay'">
  
      <div class="dtp-panel">
  
        <!-- Tabs -->
        <div class="dtp-tabs">
          <div class="dtp-tab"
               [class.active]="activeTab === 'date'"
               (click)="switchTab('date')">
            📅 Data
          </div>
  
          <div class="dtp-tab"
               [class.active]="activeTab === 'time'"
               (click)="switchTab('time')">
            🕐 Orario
          </div>
        </div>
  
        <!-- DATE -->
        <ng-container *ngIf="activeTab === 'date'">
  
          <!-- YEAR -->
          <div *ngIf="viewMode === 'year'" class="dtp-calendar">
            <div class="dtp-cal-header">
              <button type="button" (click)="yearRangeBase -= 12">‹</button>
              <span>{{ yearRangeBase - 5 }} – {{ yearRangeBase + 6 }}</span>
              <button type="button" (click)="yearRangeBase += 12">›</button>
            </div>
  
            <div class="dtp-ym-grid">
              <div *ngFor="let y of yearRange"
                   (click)="selectYear(y)"
                   [class.active]="y === viewYear">
                {{ y }}
              </div>
            </div>
          </div>
  
          <!-- MONTH -->
          <div *ngIf="viewMode === 'month'" class="dtp-calendar">
            <div class="dtp-cal-header">
              <button type="button" (click)="viewYear = viewYear - 1">‹</button>
              <span (click)="switchView('year')">{{ viewYear }}</span>
              <button type="button" (click)="viewYear = viewYear + 1">›</button>
            </div>
  
            <div class="dtp-ym-grid">
              <div *ngFor="let m of months; let i = index"
                   (click)="selectMonth(i)"
                   [class.active]="i === viewMonth">
                {{ m }}
              </div>
            </div>
          </div>
  
          <!-- DAY -->
          <div *ngIf="viewMode === 'day'" class="dtp-calendar">
            <div class="dtp-cal-header">
              <button type="button" (click)="prevMonth()">‹</button>
              <span (click)="switchView('month')">
                {{ months[viewMonth] }} {{ viewYear }}
              </span>
              <button type="button" (click)="nextMonth()">›</button>
            </div>
  
            <div class="dtp-weekdays">
              <div *ngFor="let wd of weekdays">{{ wd }}</div>
            </div>
  
            <div class="dtp-grid">
              <div *ngFor="let day of calendarDays"
                   (click)="selectDay(day.date)"
                   [class.other-month]="!day.currentMonth"
                   [class.today]="day.isToday"
                   [class.selected]="day.isSelected">
                {{ day.date.getDate() }}
              </div>
            </div>
          </div>
  
        </ng-container>
  
        <!-- TIME -->
        <div *ngIf="activeTab === 'time'" class="dtp-time">
  
          <div class="dtp-time__row">
            <div>
              <div>Ore</div>
              <input type="number"
                     min="0" max="23"
                     [ngModel]="hour24"
                     (ngModelChange)="setHour($event)">
            </div>
  
            <div>:</div>
  
            <div>
              <div>Min</div>
              <input type="number"
                     min="0" max="59"
                     [ngModel]="minute"
                     (ngModelChange)="setMinute($event)">
            </div>
          </div>
  
        </div>
  
        <!-- FOOTER -->
        <div class="dtp-footer">
            <button type="button" class="dtp-footer__now" (click)="setNow()">Adesso</button>
            <button type="button" class="dtp-footer__apply" (click)="apply()">Applica</button>
        </div>
  
      </div>
  
    </ng-template>
  
  </div>